var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"RwuYKjOKgzOXicKE0S3Ps"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from "@sentry/nextjs";

export const initSentry = () => {
  const DNS_TOKEN = process.env.NEXT_PUBLIC_DNS_TOKEN_SENTRY || null;
  const ENV_APP = process.env.NEXT_APP_ENV || "LOCAL";

  const traceRate: Record<string, number> = {
    LOCAL: 0.1,
    DEV: 0.5,
    STG: 1,
    HBAW: 1,
    MILKEN: 1,
  };

  if (!DNS_TOKEN) return;

  const tracingRate = traceRate[ENV_APP] | 1;

  Sentry.init({
    dsn: DNS_TOKEN,

    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: tracingRate,

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,

    // You can remove this option if you're not planning to use the Sentry Session Replay feature:
    integrations: [],

    // Service worker registration failure
    ignoreErrors: [
      "Rejected Error",
      // ...other known benign errors
    ],

    beforeSend(event, hint: any) {
      const message = event.message || hint?.originalException?.message || "";

      const ignoreMessages = [
        "tx_attempts_exceeded",
        "tx_ack_timeout",
        "Object captured as promise rejection with keys: data, errors",
        "Error: No current user",
        "TypeError: Failed to fetch",

        // Filter out noisy "Retries exceeded" errors from internal SDK scripts
        // The root cause is typically:
        // Content Security Policy (CSP) restrictions
        // Blocked injected scripts (e.g., by browser extensions)
        // SDK internal retries hitting limits
        "Retries exceeded",

        // Service worker registration failure
        "Error: Rejected",
      ];

      if (
        event.exception?.values?.some((ex) =>
          ignoreMessages.some((msg) => ex.value?.includes(msg))
        )
      ) {
        return null;
      }

      for (const msg of ignoreMessages) {
        if (message.includes(msg)) {
          console.warn("Ignoring Sentry error:", message);
          return null;
        }
      }

      // Catch some known noisy promise rejections
      if (
        event.message?.includes(
          'Event "Event" (type=error) captured as promise rejection'
        ) ||
        event.exception?.values?.some((ex) =>
          ignoreMessages.some((msg) => ex.value?.includes(msg))
        )
      ) {
        return null;
      }

      return event; // Allow all other events
    },
  });
};

initSentry();
